<template>
    <b-form-checkbox-group
        class="search-checkboxes search-checkboxes--gray"
        :checked="value"
        stacked
        @change="handleChanged"
    >
        <ul class="list-group list-group-flush">
            <template v-for="option in options">
                <li class="list-group-item list-group-item-action search-checkboxes__item" @click="handleItemClicked">
                    <div class="search-checkboxes__item-content">
                        <b-form-checkbox
                            class="search-checkboxes__checkbox"
                            :value="option.id"
                            :key="option.id"
                            :name="name"
                        >
                            {{ option.name }}
                        </b-form-checkbox>
                    </div>
                </li>
            </template>
        </ul>
    </b-form-checkbox-group>
</template>

<script>
    import { BFormCheckbox, BFormCheckboxGroup } from 'bootstrap-vue';

    export default {
        components: {
            BFormCheckbox,
            BFormCheckboxGroup,
        },
        props: {
            name: String,
            options: Array,
            value: Array,
        },
        methods: {
            handleChanged(checked) {
                this.$emit('input', checked);
                this.$emit('change', checked);
            },
            handleItemClicked(e) {
                const checkbox = e.target.querySelector('input[type=checkbox]');
                if(checkbox) {
                    checkbox.click();
                }
            },
            reset() {
                this.handleChanged([]);
            },
        }
    }
</script>